'use strcit';

angular.module('manageConfigPackageDetailsModule', [])
    .controller('manageConfigPackageDetailsCtrl', ['$scope', '$state', '$modalInstance', 'modalDialog', 'item', 'trsHttpService', '$filter',
        function ($scope, $state, $modalInstance, modalDialog, item, trsHttpService, $filter) {
            initStatus();
            initData();

            /**
             * [initStatus description]初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.data = {
                    obj: item,
                    items: [], // 套餐数据
                };
                $scope.status = {
                    zt: {
                        '0': '启用',
                        '1': '停用',
                        '-1': '未开通'
                    }
                };
                $scope.params = {
                    serviceid: 'mlf_billing',
                    methodname: 'queryBillingModulesByTenant',
                    TenantId: item.TENANTID
                };
            }

            /**
             * [initData description] 初始化数据
             * @return  {[type]}  [return description]
             */
            function initData() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then((data) => {
                    $scope.data.items = data;
                });
            }  

            /**
             * [cancel description]取消操作
             * @return {[type]} [description]
             */
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };

        },
    ]);
